import { useState } from "react"
import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { HugeiconsIcon } from "@hugeicons/react"
import {
  ArrowRight01Icon,
  CheckmarkCircle02Icon,
  Copy01Icon,
} from "@hugeicons/core-free-icons"
import { useAuth } from "@/lib/auth/use-auth"
import type { UIComponentReference } from "../../types/assistant.types"

interface ReferenceUIProps {
  data: UIComponentReference
}

export function ReferenceUI({ data }: ReferenceUIProps) {
  const auth = useAuth()
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    await navigator.clipboard.writeText(data.reference)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const canViewIssue = auth.isAdmin || auth.isEmployee

  return (
    <div className="mt-3 overflow-hidden rounded-xl bg-emerald-50 ring-1 ring-emerald-200 shadow-sm">
      <div className="flex items-center gap-2 border-b border-emerald-200/60 px-3.5 py-2">
        <HugeiconsIcon
          icon={CheckmarkCircle02Icon}
          size={14}
          className="text-emerald-700"
        />
        <p className="text-xs font-semibold text-emerald-900">
          Issue submitted
        </p>
      </div>
      <div className="flex items-center gap-3 px-3.5 py-3">
        <div className="flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-emerald-700">
            Reference
          </p>
          <p className="font-mono text-base font-bold text-emerald-900">
            {data.reference}
          </p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 shrink-0 hover:bg-emerald-100"
          onClick={handleCopy}
          title="Copy reference"
        >
          <HugeiconsIcon
            icon={copied ? CheckmarkCircle02Icon : Copy01Icon}
            size={16}
            className={copied ? "text-emerald-700" : "text-emerald-800"}
          />
        </Button>
      </div>
      {canViewIssue && (
        <Link
          to="/issues"
          className="flex items-center justify-between border-t border-emerald-200/60 bg-emerald-100/40 px-3.5 py-2 text-xs font-medium text-emerald-900 transition-colors hover:bg-emerald-100"
        >
          <span>View in Issues</span>
          <HugeiconsIcon icon={ArrowRight01Icon} size={14} />
        </Link>
      )}
    </div>
  )
}
